import { defineComponent as _defineComponent } from 'vue'
import { watch, computed } from 'vue';
import store from '@/store';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';

import ImageEffectsPropertiesModalsAddHeader from './components/header/ImageEffectsPropertiesCreateHeader.vue';
import ImageEffectsPropertiesModalsAddBody from './components/body/ImageEffectsPropertiesCreateBody.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectsPropertiesCreate',
  setup(__props) {

const isOpen = computed(() => {
    return store.state.imageEffectsProperties?.modalAddIsOpen || false;
});

const handleClose = () => {
    store?.dispatch('imageEffectsProperties/closeAddModal');
};

const resetForm = () => {
    store.dispatch('imageEffectsProperties/resetModalState');
};

watch(
    () => isOpen.value,
    () => {
        if (!isOpen.value) {
            resetForm();
        }
    }
);

return { __sfc: true,isOpen, handleClose, resetForm, CModal, CButton, ImageEffectsPropertiesModalsAddHeader, ImageEffectsPropertiesModalsAddBody }
}

})